export const notify_data = [
    {
        id: 1,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
    {
        id: 2,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
    {
        id: 3,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
    {
        id: 4,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
    {
        id: 5,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
    {
        id: 6,
        title: 'WorkFlow Created',
        time: '04:00 a.m.'
    },
]
